import { useEffect } from 'react';
import { DEVICE_TYPE } from '@tving/utils/src/constants/commonConstants';
import { TICKET_TIER } from '@tving/utils/src/constants/userConstants';
import getDeviceType from '@tving/utils/src/utils/common/getDeviceType/getDeviceType';
import { PageNavigator } from '@/index';
import { useAccountStore } from '@/stores';
/**
 * 비정상 페이지 진입 시 ('/') 상태 판단하여 redirect 처리 해주는 페이지
 * @constructor
 */
var RedirectPage = function () {
    var tvingAccount = useAccountStore(function (state) { return state.account; });
    var deviceType = getDeviceType();
    useEffect(function () {
        if (!(tvingAccount === null || tvingAccount === void 0 ? void 0 : tvingAccount.userToken) || deviceType !== DEVICE_TYPE.TIZEN) {
            return;
        }
        var locationPath = window.location.pathname;
        var profileNo = tvingAccount === null || tvingAccount === void 0 ? void 0 : tvingAccount.profileNo;
        if (tvingAccount && (tvingAccount === null || tvingAccount === void 0 ? void 0 : tvingAccount.ticketTier) < TICKET_TIER.STANDARD) {
            PageNavigator.replace('/welcome/login');
        }
        else if (locationPath === '/' || !profileNo) {
            PageNavigator.replace('/profile');
        }
    }, [deviceType, tvingAccount]);
    return null;
};
export default RedirectPage;
